<template>
  <div class="mx-auto">
    <v-card flat>
      <v-card-title>Informasi Laporan</v-card-title>
      <v-card-text>
        <v-list class="py-0">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <div class="caption grey--text mb-0">Jadwal Laporan</div>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-calendar-month</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text body-1 font-weight-medium">
                        {{ $getDeepObj(initValue, 'jadwal') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>Periode Laporan Berlaku</b>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="caption grey--text mb-0">Nama Sekolah</div>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-office-building-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(initValue, 'sekolah.data.nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>NPSN : </b>
                        {{ $getDeepObj(initValue, 'sekolah.data.npsn') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="caption grey--text mb-0">Nama Fasilitator</div>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(fspPendamping, 'nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>No. UKG/SIMPKB ID : </b>
                        {{ $getDeepObj(fspPendamping, 'ptk_id') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="my-3"></v-divider>
        <v-alert dense colored-border color="secondary" border="left" class="light-blue lighten-5">
          Isilah instrumen berikut berdasarkan informasi sebenarnya
        </v-alert>
        <v-row>
          <template v-for="(sch, id) in schema">
            <v-col :key="id" cols="12" sm="12" :md="sch.grid || 12" v-if="!sch.hidden">
              <div :class="['mx-3', sch.customClass]" v-if="sch.title">
                <span v-html="sch.title"></span>
              </div>
              <base-form-generator v-if="sch.instrumen" :schema="sch.instrumen" v-model="form" class="pt-5 px-3" />
              <div :class="sch.berkasClass" v-if="sch.berkas">
                <v-col v-for="(berkas, b) in sch.berkas" :key="b" cols="12">
                  <div class="body-2 indigo--text text-capitalize"> {{ berkas.label }} </div>
                  <div class="body-2 grey--text text--darken-1" v-if="berkas.desc" v-html="berkas.desc"></div>
                  <v-row class="mt-1">
                    <v-col v-if="(berkas.berkases || []).length" cols="12" sm="12" md="12" class="pt-1">
                      <v-row v-for="(file, f) in berkas.berkases" :key="f" dense>
                        <v-col cols="12" md="9" sm="12">
                          <div class="grey lighten-3 pa-2 black--text">{{ file.judul }}</div>
                        </v-col>
                        <v-col cols="12" md="3" sm="12" class="my-auto">
                          <div>
                            <v-btn
                              color="success"
                              class="text-capitalize"
                              depressed
                              :disabled="!file.url_berkas"
                              :href="file.url_berkas"
                              target="_blank"
                            >
                              <v-icon left>mdi-eye</v-icon>
                              Lihat
                            </v-btn>
                            <v-btn
                              v-if="file.is_reupload"
                              class="mx-1"
                              color="blue"
                              dark
                              depressed
                              @click="onReuploadBerkas(berkas, file)"
                            >
                              <v-icon left>mdi-upload</v-icon>
                              Unggah
                            </v-btn>
                            <v-btn
                              v-if="!isPreview"
                              class="mx-1 text-capitalize"
                              color="red"
                              dark
                              depressed
                              @click="onDelBerkas(file)"
                            >
                              <v-icon left>mdi-delete</v-icon>
                              Hapus
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0 mb-4">
                      <v-btn
                        v-if="!isPreview"
                        color="primary"
                        class="text-capitalize"
                        :disabled="(berkas.berkases || []).length >= (berkas.maks || 5)"
                        @click="onAddBerkas(berkas)"
                        depressed
                      >
                        <v-icon left>mdi-plus</v-icon> Tambah Berkas
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </div>
            </v-col>
          </template>
          <v-col cols="12" v-if="+form.is_terlaksana === 1 && !isLaporan2023">
            <div class="mx-3">
              <strong style="font-size: 18px">Lampiran Dokumentasi</strong>
              <div class="body-2">Sematkan minimal 3 Foto Dokumentasi dan maksimal 5 foto.</div>
            </div>
            <v-row class="px-3 mt-1">
              <template v-for="(berkas, key) in berkases">
                <v-col cols="12" :key="key">
                  <div><span class="px-0 body-2 grey--text" style="height: 24px">Judul Dokumentasi</span></div>
                  <v-row class="py-0">
                    <v-col cols="12" lg="8">
                      <div class="black--text grey lighten-2 pa-2" v-html="berkas.judul"></div>
                    </v-col>
                    <v-col cols="12" lg="4" class="my-auto">
                      <v-btn
                        :disabled="!berkas.url_berkas"
                        :href="berkas.url_berkas"
                        target="_blank"
                        color="success"
                        elevation="0"
                      >
                        <v-icon left dark>
                          mdi-eye
                        </v-icon>
                        Lihat
                      </v-btn>
                      <v-btn
                        v-if="isPreview && berkas.is_reupload"
                        color="primary"
                        elevation="0"
                        class="ml-3"
                        @click="onReuploadBerkas(berkas)"
                      >
                        <v-icon left dark>
                          mdi-upload
                        </v-icon>
                        Unggah
                      </v-btn>
                      <v-btn v-if="!isPreview" color="error" elevation="0" class="ml-3" @click="onDelBerkas(berkas)">
                        <v-icon left dark>
                          mdi-delete
                        </v-icon>
                        Hapus
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <v-col cols="12">
                <v-btn v-if="berkases.length < 5 && !isPreview" @click="onAddBerkas" color="secondary" elevation="0">
                  <v-icon left dark>
                    mdi-plus
                  </v-icon>
                  Tambah berkas
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            v-else-if="
              (+form.is_terlaksana !== 1 && form.k_kp_alasan_psp === 9) ||
                (isLaporan2023 && +form.k_lingkup_moda_psp === 2)
            "
          >
            <div class="mx-3">
              <strong style="font-size: 18px">Rekaman Vicon</strong>
              <div class="body-2">Sematkan minimal 1 URL Vicon.</div>
            </div>
            <v-row class="px-3 mt-1">
              <template v-for="(meeting, m) in form.data_meeting || []">
                <v-col cols="12" :key="m">
                  <div>
                    <span class="px-0 body-2 grey--text" style="height: 24px">Dokumen Vicon {{ m + 1 }}</span>
                  </div>
                  <v-row class="py-0">
                    <v-col cols="12" lg="8">
                      <v-text-field
                        :disabled="isPreview"
                        v-model="form.data_meeting[m]['url_meeting']"
                        dense
                        single-line
                        outlined
                        hide-details
                        prepend-inner-icon="mdi-video"
                        @input="getDurasi(form.data_meeting[m], m)"
                      />
                    </v-col>
                    <v-col cols="12" lg="4" class="my-auto">
                      <v-btn v-if="!isPreview" color="error" elevation="0" @click="onDelRekaman(m)">
                        <v-icon left dark>
                          mdi-delete
                        </v-icon>
                        Hapus
                      </v-btn>
                      <span class="blue--text pa-3">
                        {{ (durasis && durasis[Number(m)]) || '' }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <v-col cols="12">
                <v-btn
                  v-if="(form.data_meeting || []).length < 3 && !isPreview"
                  @click="onAddRekaman"
                  color="secondary"
                  elevation="0"
                >
                  <v-icon left dark>
                    mdi-plus
                  </v-icon>
                  Tambah URL Vicon
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <unggah-berkas
      ref="berkas"
      :reupload="berkas.is_reupload"
      :title="berkasOpt.title"
      :custom-title="berkasOpt.customTitle"
      :type="berkasOpt.type"
      :jenis="berkasOpt.jenis"
      @upload="onAddBerkasSave"
    />
  </div>
</template>
<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
import UnggahBerkas from '../../component/Berkas';
import Instrumen from './instrumen/visitasi';
import Instrumen2023 from './instrumen/visitasi2023';
import { mapActions, mapState } from 'vuex';

export default {
  components: { BaseFormGenerator, UnggahBerkas },
  mixins: [Instrumen, Instrumen2023],
  props: {
    berkases: {
      type: Array,
      default: () => [],
    },
    pspKpPa: {
      type: Object,
      default: () => {},
    },
    instrumen: {
      type: Array,
      default: () => [],
    },
    initValue: {
      type: Object,
      default: null,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: { data_meeting: [] },
      sekolah: {},
      durasis: [],
      berkas: {},
      berkasOpt: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),
    ...mapState('preferensi', {
      ptk: (state) => state.data?.ptk ?? {},
    }),

    fspPendamping() {
      const pspKpPaPendampingan = this.$getDeepObj(this.initValue, 'pspKpPaPendampingan') || {};
      return this.$getDeepObj(pspKpPaPendampingan, 'psp_profil_pa.data.ptk.data') || this.ptk;
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('laporan', ['upload', 'actions']),

    reset() {
      this.durasis = [];
      this.$set(this, 'form', { data_meeting: [] });

      this.$nextTick(() => {
        for (const key of Object.keys(this.form)) {
          if (/instrumen/.test(key) && this.form[key] === undefined) {
            this.form[key] = [];
          }
        }
      });
    },

    initForm(value) {
      if (!value) return;

      const isTerlaksana = value.pspKpPaSekolahDetail && value.pspKpPaSekolahDetail.is_terlaksana;
      if (isTerlaksana !== null) {
        this.$set(this.form, 'is_terlaksana', isTerlaksana);
      }

      let keys = ['tgl_pelaksanaan', 'kendala', 'rencana', 'pertanyaan'];
      if (this.isLaporan2023) {
        keys = ['tgl_pelaksanaan', 'k_lingkup_moda_psp'];
      }

      if (!isNaN(+isTerlaksana) && isTerlaksana === 0) {
        keys = [...keys, ...['k_kp_alasan_psp', 'alasan_lain']];
      }

      for (const key of keys) {
        this.$set(this.form, key, this.$getDeepObj(value, `pspKpPaSekolahDetail.${key}`));
      }

      // Init Meeting URL
      const meetings = this.$getDeepObj(value, 'pspKpPaSekolahDetail.data_meeting') || [];
      for (const id in meetings) {
        this.form.data_meeting.push({ url_meeting: meetings[id]['url_meeting'] });
        this.durasis[id] = this.$durasiWaktu(meetings[id]['durasi'] || null);
      }

      // Init Instrumen
      const instrumens = this.$getDeepObj(value, 'detail.psp_kp_pa_sekolah_visitasi_instrumens.data') || [];
      if (instrumens.length) {
        let result = {};
        for (const ins of instrumens) {
          const tipe = this.$getDeepObj(ins, 'm_lingkup_instrumen_psp.data.tipe') || '';

          if (tipe === 'checkbox') {
            if (result[`instrumen-${tipe}-${ins.k_lingkup_instrumen_psp}`]) {
              result[`instrumen-${tipe}-${ins.k_lingkup_instrumen_psp}`].push(ins.k_lingkup_opsi_psp);
            } else {
              result[`instrumen-${tipe}-${ins.k_lingkup_instrumen_psp}`] = [ins.k_lingkup_opsi_psp];
            }
          } else if (tipe === 'radio') {
            result[`instrumen-${tipe}-${ins.k_lingkup_instrumen_psp}`] = ins.k_lingkup_opsi_psp;
          } else {
            result[`instrumen-input-${ins.k_lingkup_instrumen_psp}`] = ins.isian || '';
          }

          if (ins.isian) {
            this.$set(this.form, `input-lain-${ins.k_lingkup_instrumen_psp}-${ins.k_lingkup_opsi_psp}`, ins.isian);
          }
        }

        for (const rs in result) {
          this.$set(this.form, rs, result[rs]);
        }
      }
    },

    getValue() {
      let values = Object.assign({}, this.form);

      const keysInstrumens = Object.keys(values).filter((key) => /instrumen/.test(key));
      for (const key of keysInstrumens) {
        const keys = key.split('-');
        const tipe = keys[1];
        const kLingkupInstrumen = keys[2];

        let result = [];
        if (tipe === 'checkbox') {
          result = (values[key] || []).map((value) => {
            return {
              k_lingkup_instrumen_psp: kLingkupInstrumen,
              k_lingkup_opsi_psp: value,
              isian: values[`input-lain-${kLingkupInstrumen}-${value}`] || '',
            };
          });
        } else {
          if (values[key]) {
            if (tipe === 'radio') {
              result = [
                {
                  k_lingkup_instrumen_psp: kLingkupInstrumen,
                  k_lingkup_opsi_psp: values[key],
                  isian: values[`input-lain-${kLingkupInstrumen}-${values[key]}`] || '',
                },
              ];
            } else {
              result = [
                {
                  k_lingkup_instrumen_psp: kLingkupInstrumen,
                  isian: values[key],
                },
              ];
            }
          }
        }

        if (values.instrumen) {
          values.instrumen = [...values.instrumen, ...result];
        } else {
          values.instrumen = result;
        }

        delete values[key];
      }

      const inputsLain = Object.keys(values).filter((key) => /input-lain/.test(key));
      for (const input of inputsLain) {
        delete values[input];
      }

      if (this.isLaporan2023) {
        values['is_terlaksana'] = 1;
      }

      return values;
    },

    getDurasi(item, index) {
      if (!item.url_meeting) return;
      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item.url_meeting }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },

    onAddBerkas(berkas) {
      if (this.isPreview) return;
      this.berkas = {};
      this.berkasOpt = {
        type: berkas.type,
        title: berkas.label,
        jenis: berkas.key,
        customTitle: `Lampiran ${berkas.label}`,
      };

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onAddBerkasSave(berkas) {
      if (this.$isObject(this.berkas)) {
        this.onReuploadBerkasSave(berkas);
        return;
      }

      const pspKpPaPendampinganId = this.$getDeepObj(this.initValue, 'pspKpPaPendampingan.psp_kp_pa_pendampingan_id');
      const pspKpPaSekolahId = this.$getDeepObj(this.initValue, 'pspKpPaSekolahId');
      const attr = {
        endpoint: `pendampingan-lingkup/${pspKpPaPendampinganId}/berkas-visitasi/${pspKpPaSekolahId}/insert`,
      };

      const params = new FormData();
      params.append('judul', berkas.judul);
      params.append('jenis', berkas.jenis);
      if (berkas.url) {
        params.append('url', berkas.url);
      } else {
        params.append('file', berkas.file);
      }

      this.$refs.berkas.startLoading();
      this.upload({ attr, params })
        .then(() => {
          this.$emit('refresh');
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onDelBerkas(berkas) {
      const action = 'delete';
      const id = berkas.psp_kp_pa_sekolah_visitasi_berkas_id;
      const pspKpPaPendampinganId = this.$getDeepObj(this.initValue, 'pspKpPaPendampingan.psp_kp_pa_pendampingan_id');
      const pspKpPaSekolahId = this.$getDeepObj(this.initValue, 'pspKpPaSekolahId');
      const endpoint = `pendampingan-lingkup/${pspKpPaPendampinganId}/berkas-visitasi/${pspKpPaSekolahId}`;

      this.$confirm('Anda yakin ingin menghapus berkas ?', 'Hapus berkas', {
        tipe: 'error',
      }).then(() => {
        this.actions({ endpoint, id, action }).then(() => {
          this.$emit('refresh', 'berkas');
        });
      });
    },

    onReuploadBerkas(berkas) {
      this.title = 'Foto Dokumentasi Kegiatan';
      this.berkas = berkas;

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onReuploadBerkasSave(berkas) {
      const pspKpPaPendampinganId = this.$getDeepObj(this.initValue, 'pspKpPaPendampingan.psp_kp_pa_pendampingan_id');
      const pspKpPaSekolahId = this.$getDeepObj(this.initValue, 'pspKpPaSekolahId');
      const berkasId = this.berkas.psp_kp_pa_sekolah_visitasi_berkas_id || '';
      const attr = {
        endpoint: `pendampingan-lingkup/${pspKpPaPendampinganId}/berkas-visitasi/${pspKpPaSekolahId}/${berkasId}/reupload`,
      };

      const params = new FormData();
      params.append('file', berkas.file);

      this.$refs.berkas.startLoading();
      this.upload({ attr, params })
        .then(() => {
          this.$emit('refresh');
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onAddRekaman() {
      this.form.data_meeting.push({ url_meeting: '' });
    },

    onDelRekaman(id) {
      this.form.data_meeting.splice(id, 1);
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
